import { HeroHome } from "@/modules/home/ui/components/Hero"
import { LandingPageLayout } from "@/modules/layout/ui/navbar/LandingPageLayout"
import StepsSection from "../components/StepSection"
import CtaDashboardSection from "../components/CTADashboard"
import AIFeaturesSection from "../components/AIFeatures"
import IntegrationsSection from "../components/Integrations"
import ShowcaseSection from "../components/Showcase"
import OnboardingFeaturesSection from "../components/OnboardingFeatures"

export default function LandingPage() {
  return (
    <LandingPageLayout>
      <section id="home">
        <HeroHome />
      </section>
      <section id="how-it-works">
        <StepsSection />
      </section>
      <section id="showcase">
        <ShowcaseSection />
      </section>
      <section id="ai-features">
        <AIFeaturesSection />
      </section>
      <section id="onboarding-features">
        <OnboardingFeaturesSection />
      </section>
      <section id="integrations">
        <IntegrationsSection />
      </section>
      {/* <section id="testimonials">
        <TestimonialsSection />
      </section> */}
      {/* <section id="pricing">
        <Pricing />
      </section> */}
      <section id="cta">
        <CtaDashboardSection />
      </section>
    </LandingPageLayout>
  )
}
